<div class="modal-header">
  <div>
    <h4 class="modal-title" id="exampleModalLabel">
      {{ "advertisingCampaign.create.title" | translate }}
    </h4>
    <h5>
      {{
        "enumMapping.createAdvertisingCampaign." + selectedOption.toString()
          | translate
      }}
    </h5>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onClickDismissAll()"
  ></button>
</div>
<div class="modal-body p-b-0">
  <form
    novalidate
    class="theme-form creation-form p-0"
    (ngSubmit)="submit()"
    [formGroup]="advertisingCampaignForm"
  >
    <div
      *ngIf="
        selectedOption ==
        section.ADMIN_CREATE_ADVERTISING_CAMPAIGN_FOR_FRANCHISE
      "
    >
      <div class="form-group">
        <label class="label"
          >{{
            "advertisingCampaign.create.options.franchise.franchise" | translate
          }}
          *</label
        >
        <ng-select
          class="singleChose"
          formControlName="franchise"
          [items]="franchiseList"
          [multiple]="false"
          [closeOnSelect]="true"
          [placeholder]="
            'advertisingCampaign.create.placeholders.selectFranchise' | translate
          "
          [required]="true"
          (change)="fetchFranchised()"
        >
        </ng-select>
      </div>
    </div>
    <div class="form-group" *ngIf="showLocationPartner">
      <label class="label"
        >{{ "advertisingCampaign.create.locations" | translate }} *</label
      >
      <div
        *ngIf="
          selectedOption ===
            section.ADMIN_CREATE_ADVERTISING_CAMPAIGN_FOR_FRANCHISE;
          else locationPartner
        "
      >
        <ng-select
          formControlName="locationPartners"
          [items]="resultAllCompanyNames"
          [multiple]="
            selectedOption ===
            section.ADMIN_CREATE_ADVERTISING_CAMPAIGN_FOR_FRANCHISE
          "
          [closeOnSelect]="false"
          [placeholder]="
            'advertisingCampaign.create.placeholders.selectLocations'
              | translate
          "
          [required]="true"
        >
          <ng-template ng-header-tmp>
            <div class="form-check checkbox checkbox-primary mb-0">
              <input
                class="form-check-input"
                id="checkbox-select-all"
                type="checkbox"
                [checked]="isAllSelected()"
                (click)="selectAllLocations($event)"
              />
              <label class="form-check-label label" for="checkbox-select-all">
                {{ "select.selectAllLocations" | translate }}
              </label>
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div class="form-check checkbox checkbox-primary mb-0 ml-10">
              <input
                class="form-check-input m-r-10"
                type="checkbox"
                [checked]="
                  advertisingCampaignForm
                    .get('locationPartners')
                    ?.value?.includes(item)
                "
              />
              <label class="form-check-label label">{{ item }}</label>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <ng-template #locationPartner>
        <select class="form-select" formControlName="locationPartners" required>
          <option selected="" disabled="" [value]="null">
            {{
              "advertisingCampaign.create.placeholders.selectLocation"
                | translate
            }}
          </option>
          <option *ngFor="let item of resultAllCompanyNames" [ngValue]="item">
            {{ item | translate }}
          </option>
        </select>
      </ng-template>
    </div>
    <div class="m-b-20">
      <label class="label"
        >{{ "advertisingCampaign.create.customizeAd" | translate }} *</label
      >
      <app-video-guidelines-and-upload
        (emitFileName)="catchFileName($event)"
        [isShowGuide]="false"
      ></app-video-guidelines-and-upload>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="onClickBack()">
    {{ "buttons.cancel" | translate }}
  </button>
  <button
    class="btn btn-primary button-right"
    [disabled]="!advertisingCampaignForm.valid || filename == null"
    type="submit"
    (click)="submit()"
  >
    {{ "buttons.confirm" | translate }}
  </button>
</div>
